"use client";

import { Eye, EyeOff } from "@app-foundation/icons/lucide";
import { PasswordInput as SharedPasswordInput } from "@app-foundation/ui-controls";
import "@app-foundation/ui-controls/styles.css";
import type { ComponentProps } from "react";

export function PasswordInput({ className = "", ...props }: Omit<ComponentProps<"input">, "type">) {
  return <SharedPasswordInput {...props} showLabel="显示密码" hideLabel="隐藏密码"
    className={`w-full rounded-[var(--radius-input)] border border-[var(--color-line-strong)] bg-[var(--color-sunken)] py-3 pl-4 pr-12 text-sm text-[var(--color-paper)] outline-none placeholder:text-[var(--color-ghost)] focus-visible:border-[var(--color-accent)] ${className}`}
    toggleClassName="absolute inset-y-0 right-0 flex w-11 items-center justify-center rounded-[var(--radius-input)] text-[var(--color-mist)] hover:text-[var(--color-paper)] focus-visible:outline-2 focus-visible:outline-[var(--color-accent)] disabled:cursor-not-allowed disabled:opacity-50"
    renderToggle={visible => visible ? <EyeOff size={20} aria-hidden="true" /> : <Eye size={20} aria-hidden="true" />} />;
}
